module.exports = __webpack_public_path__ + "img/panneau-grillage-half.f0b45ba.svg";